export const ADD_USER = "ADD_USER";
export const GET_USER = "GET_USER";
export const SEARCH_USER = "SEARCH_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SEARCHING_USER = "SEARCHING_USER";
export const SELECT_USER  = "SELECT_USER";
export const CHANGE_TEXT  = "CHANGE_TEXT";
